import bilyoner from './base';
import ag from './ag-base';

export default { ...bilyoner, ...ag };
